export const exportXlsxConfig = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/xlsx',
  },
  responseType: 'arraybuffer',
} as const;
